export enum SIGN_IN_CORE {
    /**
     * @value Did not receive the email?
     */
    EMAIL_NOT_RECEIVED = 'EMAIL_NOT_RECEIVED',
    /**
     * @value Sign in with %PROVIDER%
     */
    LOGIN_GENERIC_SIGN_IN = 'LOGIN.GENERIC_SIGN_IN',
    /**
     * @value Powered by
     */
    POWERED_BY = 'LOGIN_POWERED_BY',
    /**
     * @value Try another address
     */
    TRY_ANOTHER_ADDRESS = 'TRY_ANOTHER_ADDRESS',
}
